import BaseCellHandler from './BaseCellHandler';
import WordCloudWrapper from '@/views/storyboard/charts/wordcloud';
import {WordCloudChartData} from 'entities/chartData';


class WordCloudCellHandler extends BaseCellHandler {
    endpointUrl = window.URLS.generateWordCloud;

    renderContent() {
        const {data, queryDuration} = this.state;

        const {
            chartQuery,
            chartSettingsView,
        } = this.props;

        return (
            <WordCloudWrapper
                data={data as WordCloudChartData[]}
                chartQuery={chartQuery}
                queryDuration={queryDuration}
                chartSettingsView={chartSettingsView}
            />
        );
    }
}

export default WordCloudCellHandler;
